// extracted by mini-css-extract-plugin
export default {"errorBox":"ErrorComponent_errorBox__PD-g6","btn":"ErrorComponent_btn__BFiz4"};